/**
 * AQ Assist modal walkthrough steps (uses shared IsfPageTour UI).
 * Targets must match data-tour attributes on FaqAskModal / FaqAskPanel.
 */
export function buildFaqAssistTourSteps(context = {}) {
  const {
    hasModules = false,
    hasRecentChats = false,
    hasUsage = false,
    hasComposer = false,
  } = context;

  const steps = [
    {
      id: "welcome",
      placement: "center",
      title: "Welcome to AQ Assist",
      body: "AQ Assist is AI-enabled help for AQ Trials. Ask a how-to question and get a live response in chat. Reopen this guide anytime from Guide.",
    },
    {
      id: "guide-button",
      target: '[data-tour="faq-assist-guide"]',
      placement: "bottom",
      title: "Assist guide",
      body: "Use Guide inside AQ Assist to replay this walkthrough.",
    },
    {
      id: "new-chat",
      target: '[data-tour="faq-assist-new-chat"]',
      placement: "bottom",
      title: "New chat",
      body: "Start a fresh conversation. Each chat is kept in Recent so you can return later.",
    },
    {
      id: "feedback-totals",
      target: '[data-tour="faq-assist-feedback-totals"]',
      placement: "bottom",
      title: "Feedback totals",
      body: "When you rate answers as helpful or not helpful, running totals appear here across your recent chats.",
    },
    {
      id: "recent",
      target: '[data-tour="faq-assist-recent"]',
      placement: "right",
      title: "Recent chats",
      body: "Open a previous chat to continue from where you left off. Thumbs icons on a row show feedback already given in that chat.",
      when: () => hasRecentChats,
    },
    {
      id: "modules",
      target: '[data-tour="faq-assist-modules"]',
      placement: "left",
      title: "Modules",
      body: "Pick the module your question is about before you ask. The list only includes modules your organisation can access.",
      when: () => hasModules,
    },
    {
      id: "usage",
      target: '[data-tour="faq-assist-usage"]',
      placement: "left",
      title: "Today’s usage",
      body: "Shows how many asks you and your organisation have used today, and how many are left.",
      when: () => hasUsage,
    },
    {
      id: "thread",
      target: '[data-tour="faq-assist-thread"]',
      placement: "bottom",
      title: "Conversation",
      body: "Your questions and live AQ Assist answers appear here. After an answer, use Yes / No to rate it. Not helpful asks for a short note, then can send to support.",
      when: () => hasComposer,
    },
    {
      id: "composer",
      target: '[data-tour="faq-assist-composer"]',
      placement: "top",
      title: "Ask a question",
      body: "Type a clear how-to question (for example “How do I…?”), then Send. Follow-up chips under an answer send the next question for you.",
      when: () => hasComposer,
    },
    {
      id: "close",
      target: '[data-tour="faq-assist-close"]',
      placement: "bottom",
      title: "Close",
      body: "AQ Assist only closes from this button — clicking outside the window will not dismiss it.",
    },
    {
      id: "done",
      placement: "center",
      title: "Ready to ask",
      body: "Choose a module, ask your how-to question, and use feedback when an answer helps — or does not. Use Guide here anytime for a refresher.",
    },
  ];

  return steps.filter((step) => (step.when ? step.when(context) : true));
}
